import DOMPurify from "dompurify";

/**
 * Global DOMPurify hook — applies to every sanitize() call in the app.
 *
 * Links pasted from Word carry target="_blank" with no rel, because Froala's
 * linkAlwaysBlank only applies to links created through its own insert flow.
 * Enforcing it here covers pasted content, versions already stored without it,
 * and anything published through the API without going through the editor.
 */
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

/**
 * Sanitizes HTML for rendering (e.g., Terms & Conditions).
 *
 * `style` is allowed because Word-pasted ordered lists carry
 * `list-style-type` (upper-alpha, lower-roman), which the Terms & Conditions agreement's
 * cross-references depend on — "Section 5(A)" must render as A, not 1.
 */
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "strong", "em", "u", "ol", "ul", "li", "a", "br", "span"],
    ALLOWED_ATTR: ["href", "target", "rel", "style", "start"],
  });
